import {
  RECEIVE_LOCAL_STUDIES_LIST,
  RESET_REDUX,
  RESET_LOCAL_STUDIES_LIST,
  REQUEST_SET_STUDY,
  RESET_SET_STUDY,
  RECEIVE_SET_STUDY,
  SET_LOCAL_FOLDERPATH,
  REQUEST_LOCAL_STUDIES_LIST,
  RECEIVE_TEMPLATE,
  SET_TEMPLATE_PROMPT,
  REQUEST_SET_LOCAL_STUDY_TEMPLATE,
  RESET_TEMPLATE,
  REQUEST_SET_REMOTE_STUDY_TEMPLATE,
  RECEIVE_REMOTE_STUDIES_LIST,
  REQUEST_REMOTE_STUDIES_LIST,
  RESET_REMOTE_STUDIES_LIST,
  ADD_STUDY_TO_REDUX,
} from "../actions/index";
import produce from "immer";
import { studyFixture } from "../constants/Fixtures/studyFixture";
const initialState = {
  // Studies and participants stored on the local server

  localStudiesReceived: true,
  localStudiesFetching: false,

  localStudyInfoById: {
    [studyFixture.study.studyInfo.id]: {
      ...studyFixture.study.studyInfo,
    },
  },
  localStudyAllIds: [],

  remoteStudiesReceived: false,
  remoteStudiesFetching: false,

  remoteStudyInfoById: {},
  remoteStudyAllIds: [],

  localFolderpath: null,
  setStudyFetching: false,

  templatePrompt: false,
  templateFetching: false,
  templateReceieved: false,
  templateReceivedInfo: null,
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ADD_STUDY_TO_REDUX: {
        draft.localStudyInfoById[action.study.study.studyInfo.id] = {
          ...action.study.study.studyInfo,
          ...action.study,
        };

        break;
      }
      case REQUEST_LOCAL_STUDIES_LIST: {
        draft.localStudiesReceived = false;
        draft.localStudiesFetching = true;
        break;
      }

      case RECEIVE_LOCAL_STUDIES_LIST: {
        draft.localStudyInfoById = action.studies;
        draft.localStudyAllIds = Object.keys(action.studies);
        draft.localStudiesReceived = true;
        draft.localStudiesFetching = false;
        break;
      }

      case RESET_LOCAL_STUDIES_LIST: {
        draft.localStudiesReceived = false;
        draft.localStudiesFetching = false;
        draft.localStudyInfoById = {};
        draft.localStudyAllIds = [];
        break;
      }

      case REQUEST_REMOTE_STUDIES_LIST: {
        draft.remoteStudiesReceived = false;
        draft.remoteStudiesFetching = true;
        break;
      }

      case RECEIVE_REMOTE_STUDIES_LIST: {
        draft.remoteStudyInfoById = action.studies;
        draft.remoteStudyAllIds = Object.keys(action.studies);
        draft.remoteStudiesReceived = true;
        draft.remoteStudiesFetching = false;

        break;
      }

      case RESET_REMOTE_STUDIES_LIST: {
        draft.remoteStudiesReceived = false;
        draft.remoteStudiesFetching = false;
        draft.remoteStudyInfoById = {};
        draft.remoteStudyAllIds = [];
        break;
      }

      case REQUEST_SET_STUDY: {
        draft.setStudyFetching = true;
        break;
      }
      case RESET_SET_STUDY: {
        draft.setStudyFetching = false;
        break;
      }
      case RECEIVE_SET_STUDY: {
        draft.setStudyFetching = false;
        break;
      }

      case SET_LOCAL_FOLDERPATH: {
        draft.localFolderpath = action.localFolderpath;
        break;
      }

      case REQUEST_SET_LOCAL_STUDY_TEMPLATE: {
        draft.templateFetching = true;
        break;
      }

      case REQUEST_SET_REMOTE_STUDY_TEMPLATE: {
        draft.templateFetching = true;
        break;
      }
      case RECEIVE_TEMPLATE: {
        draft.templateReceieved = action.state;
        draft.templateFetching = false;
        draft.templateReceivedInfo = action.templateReceivedInfo;
        break;
      }
      case RESET_TEMPLATE: {
        draft.templateFetching = false;
        break;
      }
      case SET_TEMPLATE_PROMPT: {
        draft.templatePrompt = action.templatePrompt;
        break;
      }

      case RESET_REDUX:
        let renewState = {};
        renewState = {
          ...initialState,
          localStudyInfoById: draft.localStudyInfoById,
        };
        return renewState;
      default:
        return draft;
    }
  });
